module.exports = __webpack_public_path__ + "static/media/back_of_right_thumb.12f2a85c.svg";